import { createAxiosInstance } from "./index";
import hostConfig from "@/config/hostResolver";

const baseUrl = process.env.VUE_APP_CONTENT_URL ?? `${hostConfig.apiBaseUrl}/content-service`;

class ContentServiceV2 {
  constructor() {
    this.apiClient = createAxiosInstance(baseUrl);
  }

  async uploadContentWithSignedUrl(
    url,
    attachment,
    includeContentLength = false,
    additionalOptions = {},
    contentType = "application/octet-stream"
  ) {
    const headers = {
      "Content-Type": contentType,
    };
    if (includeContentLength) headers["X-Upload-Content-Length"] = attachment.size;
    return (
      await this.apiClient.put(url, attachment, {
        headers,
        ...additionalOptions,
      })
    )?.data;
  }
}

export default ContentServiceV2;
